import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api";
import { CheckCircle2, Trash2 } from "lucide-react";

function RequestsList() {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = () => {
    api
      .get("/api/requests")
      .then((res) => setRequests(res.data || []))
      .catch((err) => console.error("Error fetching requests", err));
  };

  const approveRequest = async (id) => {
    try {
      await api.post(`/api/requests/${id}/approve`);
    } catch (err) {
      // Don't show failure yet — sometimes server succeeded but browser couldn't read response (CORS/network)
      console.warn("Approve returned error, verifying by refetching...", err);
    }

    // ✅ Always refetch and verify
    try {
      const res = await api.get("/api/requests");
      const updated = res.data || [];
      setRequests(updated);

      const stillExists = updated.some((r) => r.id === id);

      if (stillExists) {
        alert("❌ Failed to approve (request still exists).");
      } else {
        alert("✅ Request approved and moved to work orders!");
      }
    } catch (err) {
      console.error("Error refetching requests", err);
      alert("✅ Approved (but refresh failed). Please reload the page.");
    }
  };

  const deleteRequest = async (id) => {
    if (!window.confirm("Delete this request?")) return;
    try {
      await api.delete(`/api/requests/${id}`);
      fetchRequests();
    } catch (err) {
      console.error("Error deleting request", err);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err.message ||
        "Unknown error";
      alert(`❌ Failed to delete request: ${msg}`);
    }
  };

  return (
    <div className="main-content">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <h1>📝 Work Order Requests</h1>
      </div>

      <div className="table-wrapper">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Date</th>
                <th>Line</th>
                <th>Machine</th>
                <th>Task</th>
                <th>Lead Time</th>
                <th>Assignee</th>
                <th style={{ width: 120 }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {requests.map((req) => (
                <tr key={req.id}>
                  <td>{req.id}</td>
                  <td>{req.date}</td>
                  <td>{req.line}</td>
                  <td>{req.machine}</td>
                  <td style={{ maxWidth: 420, whiteSpace: "pre-wrap" }}>
                    {req.task}
                  </td>
                  <td>{req.lead_time}</td>
                  <td>{req.assignee}</td>

                  <td style={{ whiteSpace: "nowrap" }}>
                    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                      <button
                        type="button"
                        className="icon-btn"
                        onClick={() => approveRequest(req.id)}
                        title="Approve"
                      >
                        <CheckCircle2 size={16} />
                      </button>

                      <button
                        type="button"
                        className="icon-btn danger"
                        onClick={() => deleteRequest(req.id)}
                        title="Delete"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}

              {requests.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ padding: 14, color: "#9ca3af" }}>
                    No requests right now.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default RequestsList;
